import { createContext, useCallback, useContext, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { EnquiryForm } from "@/components/site/EnquiryForm";

const EnquiryContext = createContext({ openEnquiry: () => {} });

export function EnquiryProvider({ children }) {
  const [state, setState] = useState({ open: false, preset: {} });
  const openEnquiry = useCallback((preset = {}) => setState({ open: true, preset }), []);

  return (
    <EnquiryContext.Provider value={{ openEnquiry }}>
      {children}
      <Dialog open={state.open} onOpenChange={(open) => setState((s) => ({ ...s, open }))}>
        <DialogContent data-lenis-prevent data-testid="enquiry-dialog"
          className="max-w-lg bg-paper border-ink/10 rounded-3xl max-h-[92vh] overflow-y-auto">
          <DialogHeader className="text-left">
            <p className="eyebrow text-terra">Don't just dream it</p>
            <DialogTitle className="font-display text-3xl font-extrabold tracking-tight">Let us call you back.</DialogTitle>
            <DialogDescription className="text-stone-600">
              {state.preset.trip_title ? `About: ${state.preset.trip_title}` : "Tell us where you want to go. We'll take it from there."}
            </DialogDescription>
          </DialogHeader>
          <EnquiryForm preset={state.preset} idPrefix="dialog" onDone={() => setState((s) => ({ ...s, open: false }))} />
        </DialogContent>
      </Dialog>
    </EnquiryContext.Provider>
  );
}

export const useEnquiry = () => useContext(EnquiryContext);
